import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  FormCheckbox,
  FormSelect,
  FormEmail,
  FormTextField,
  FormTextarea,
} from '@uncinc/uncinc-react-kitchen-sink';

import CheckAll from '../CheckAll';
import Button from '../Button';

import './style.scss';

export interface ExportProps {
  isLoading: boolean;
  className?: string;
}

const Export: React.FC<ExportProps> = (props) => {
  const { className, isLoading } = props;
  const { t } = useTranslation();

  const classNames = c('SearchAllContent__Export', className);

  return (
    <div className={classNames}>
      <h3>{t('components.export.title')}</h3>
      <CheckAll />
      <FormSelect
        wrapperClassName="Searchkit__Facet__RefinementSelect"
        className="SearchAllContent__Export__format Searchkit__Facet__RefinementSelect__item"
        title={t('components.export.format')}
        required
        fieldName="format"
        options={{
          ris: 'ris',
          bibtex: 'bibtex',
          endnote8: 'endnote8',
          endnote7: 'endnote7',
          tagged: 'tagged',
          marc: 'marc',
          rtf: 'rtf',
        }}
      />
      <FormCheckbox
        wrapperClassName="SearchAllContent__Export__mail"
        title={t('components.export.email')}
        fieldName="mailTo"
      />
      <div className="SearchAllContent__Export__wrapper emaildetails">
        <FormEmail
          title="E-mail"
          fieldName="email"
        />
        <FormTextField
          title="Subject"
          fieldName="subject"
        />
        <FormTextarea
          title="Message"
          fieldName="message"
        />
      </div>
      <Button className="SearchAllContent__Export__submit" type="secondary" htmlType="submit" loading={isLoading}>
        {t('components.export.export')} <span className="loader">⏳</span>
      </Button>
    </div>
  );
};

export default Export;
